module.exports = __webpack_public_path__ + "img/vladislav.p__600x600.0b549c9d.jpg";